/**
 * Since there are several types of forms, both order-form and order-form-2-step, this is a service which adds constious custom
 * validations to the forms.
 * @constructor
 */
function CustomFormValidator() {
}

/**
 * Adds some custom validations to the form
 */
CustomFormValidator.prototype.addCustomValidations = function (form) {


    if (form.find("input[digits]").length) {
        form.find("input[digits]").rules("add", "digits"); // Any input with an attribute called "digits", should contain only digits.

        this.addAtCharacterValidation(form);
        this.noEmptyFields(form);
        this.fixZipStateValues(form);
    }

};

/**
 * Adds a validation method which disallows the character "@" in all input fields which are not of the type email.
 */
CustomFormValidator.prototype.addAtCharacterValidation = function (form) {
    jQuery.validator.addMethod("noAtCharacter", function (value, element) {
        return !(/\@/.test(value));
    }, "This field cannot contain the value @.");

    const elements = form.find('input:not([type="email"])');
    jQuery.each(elements, function (element) {
        jQuery(elements[element]).rules("add", "noAtCharacter");
    });

    jQuery('#lastName').rules("add", "noAtCharacter");

};

/**
 * Function for checking empty input fields for required ones.
 */
CustomFormValidator.prototype.noEmptyFields = function (form) {
    const elements = form.find('input[required]');
    console.log('a', elements);
    elements.on('blur', function(){
        console.log(jQuery(this));
        if(jQuery(this).val().replace(/^\s+|\s+$/g, '').length <= 0) {
            jQuery(this).val('');
        }
    });
};
/**
 * Function for preventing wrong ZIP code and state.
 */
CustomFormValidator.prototype.fixZipStateValues = function (form) {
    const postal = form.find('#invoiceZipcode');
    const city = form.find('#invoiceCity');

    postal.on('blur', function(){
        const postalVal = postal.val();
        const onlyNumbers = /^[1-9]\d*$/g; // Regex to search only for numbers.
        if ( postalVal.length < 2 ) {
            postal.val('');
        } else {
            if(!onlyNumbers.test( postalVal ) ) {
                postal.val('');
            }
        }
    });
    postal.on('change', function(){
        city.val('');
    });
    city.on('focus', function(){
        if ( postal.val().length <= 0 ) {
            city.val('');
        }
    });
};

/**
 * Functions for custom place name look up from ZIP code.
 *
 * Comments due to the non-traditional nature of obtaining data:
 * Fetch and AJAX requests yielding cors and header issues.
 * The following methodology follows loosely an example
 * provided by Geonames (the API we use for the lookup).
 *
 * Ref: http://www.geonames.org/export/ajax-postalcode-autocomplete.html
 */
CustomFormValidator.prototype.zipLookup = function (form) {
    if (!form) {
        return;
    }

    function JSONscriptRequest(fullUrl) {
        // REST request path
        this.fullUrl = fullUrl;
        // Keep IE from caching requests
        this.noCacheIE = '&noCacheIE=' + (new Date()).getTime();
        // Get the DOM location to put the script tag
        this.headLoc = document.getElementsByTagName("head").item(0);
        // Generate a unique script tag id
        this.scriptId = 'YJscriptId' + JSONscriptRequest.scriptCounter++;
    }

    // Static script ID counter
    JSONscriptRequest.scriptCounter = 1;

    // buildScriptTag method
    JSONscriptRequest.prototype.buildScriptTag = function () {

        // Create the script tag
        this.scriptObj = document.createElement("script");

        // Add script object attributes
        this.scriptObj.setAttribute("type", "text/javascript");
        this.scriptObj.setAttribute("src", this.fullUrl + this.noCacheIE);
        this.scriptObj.setAttribute("id", this.scriptId);
    };

    // addScriptTag method
    JSONscriptRequest.prototype.addScriptTag = function () {
        // Create the script tag
        this.headLoc.appendChild(this.scriptObj);
    };

    // Init
    const zipCodeInput = document.getElementById('invoiceZipcode');
    const cityInput = document.getElementById('invoiceCity');

    if (!zipCodeInput || !cityInput) {
        return;
    }

    zipCodeInput.addEventListener('blur', postalCodeLookup);

    // Store original country code value in global function scope
    const country = document.querySelector("[name=country]");

    if (!country) {
        return;
    }

    var originalCountryVal = country.value;

    // postalcodes is filled by the JSON callback and used by the mouse event handlers of the suggest box
    var postalcodes;

    // this function will be called by our JSON callback
    // the parameter jData will contain an array with postalcode objects
    function getLocation(jData) {
        var placeNames = [];
        var newPostalCodes = [];

        if (jData == null) {
            // There was a problem parsing search results
            return;
        }

        // Filter so the same place name only occurs once
        for (var i = 0; i < jData.postalcodes.length; i++) {
            if (jQuery.inArray(jData.postalcodes[i].placeName, placeNames) === -1) {

                jData.postalcodes[i].placeName = jData.postalcodes[i].placeName.trim();

                placeNames.push(jData.postalcodes[i].placeName);
                newPostalCodes.push(jData.postalcodes[i]);
            }
        }

        jData.postalcodes = newPostalCodes;

        // save place array in 'postalcodes' to make it accessible from mouse event handlers
        postalcodes = jData.postalcodes;

        if (postalcodes.length > 1) {
            // we got several places for the postalcode
            // make suggest box visible
            document.getElementById('suggestBoxElement').style.visibility = 'visible';
            var suggestBoxHtml = '';

            // iterate over places and build suggest box content
            for (i = 0; i < jData.postalcodes.length; i++) {
                // for every postalcode record we create a html div
                // each div gets an id using the array index for later retrieval
                // define mouse event handlers to select a place on click
                // all events receive the postalcode array index as input parameter
                suggestBoxHtml += "<div class='suggestions' id=pcId" + i + " data-index='" + i + "' data-countryCode='" + postalcodes[i].countryCode + "'>" + postalcodes[i].placeName + '</div>';
            }
            // display suggest box
            document.getElementById('suggestBoxElement').innerHTML = suggestBoxHtml;
            activateSuggestionsEvents();
        } else {
            if (postalcodes.length == 1) {
                // exactly one place for postalcode
                // directly fill the form, no suggest box required
                const placeInput = document.getElementById("invoiceCity");
                placeInput.value = postalcodes[0].placeName;
            }
            closeSuggestBox();
        }

        // Check if lookup is DK, GL or FO/FL
        if (postalcodes.length > 0) {
            var countryCodesToCheck = ["DK", "GL", "FO", "FL"];
            var countryCode = postalcodes[0].countryCode;

            if (countryCodesToCheck.toString().search(countryCode) !== -1) {
                /**
                 *  Geonames and Norvital systems use a different code
                 *  for the Faroe Islands (sometimes).
                 */
                if (countryCode === "FL") {
                    countryCode = "FO";
                }

                var country = document.querySelector("[name=country]");

                if (!country) {
                    return;
                }

                country.value = countryCode;
            }
        }
    }

    window.getLocation = getLocation;

    // Function to activate suggestions item events
    function activateSuggestionsEvents() {
        const suggestBox = document.getElementById('suggestBoxElement');

        if (!suggestBox) {
            return;
        }

        const suggestions = suggestBox.querySelectorAll('.suggestions');
        const placeInput = document.getElementById("invoiceCity");

        suggestions.forEach(function (suggestion, index) {
            suggestion.addEventListener('click', function () {
                placeInput.value = postalcodes[index].placeName;
                closeSuggestBox();
            });
        });
    }

    function closeSuggestBox() {
        document.getElementById('suggestBoxElement').innerHTML = '';
        document.getElementById('suggestBoxElement').style.visibility = 'hidden';
    }

    // this function is called when the user leaves the postal code input field
    // it call the geonames.org JSON webservice to fetch an array of places
    // for the given postal code
    function postalCodeLookup() {
        if (!originalCountryVal) {
            return;
        }

        const countryVal = originalCountryVal;

        const geonamesPostalCodeCountries = ["AD", "AR", "AS", "AT", "AU", "AX", "BD", "BE", "BG", "BM", "BR", "BY", "CA", "CH", "CL", "CO", "CR", "CZ", "DE", "DK", "DO", "DZ", "ES", "FI", "FM", "FO", "FR", "GB", "GF", "GG", "GL", "GP", "GT", "GU", "HR", "HU", "IE", "IM", "IN", "IS", "IT", "JE", "JP", "LI", "LK", "LT", "LU", "LV", "MC", "MD", "MH", "MK", "MP", "MQ", "MT", "MX", "MY", "NC", "NL", "NO", "NZ", "PH", "PK", "PL", "PM", "PR", "PT", "PW", "RE", "RO", "RU", "SE", "SI", "SJ", "SK", "SM", "TH", "TR", "UA", "US", "UY", "VA", "VI", "WF", "YT", "ZA", "GR"];

        if (geonamesPostalCodeCountries.toString().search(countryVal) == -1) {
            return; // selected country not supported by geonames
        }

        postalcode = document.getElementById('invoiceZipcode').value;

        if (!postalcode) {
            return;
        }

        // display 'loading' in suggest box
        document.getElementById('suggestBoxElement').style.visibility = 'visible';
        document.getElementById('suggestBoxElement').innerHTML = '<small><i>loading ...</i></small>';

        /**
         * Comments due to the non-traditional nature of obtaining data:
         *
         * One alternative that we could look deeper into is to use a cors
         * proxy. Hosted or self hosted. Would require more time to set up.
         *
         * Ref: https://cors-anywhere.herokuapp.com/
         */
        request = 'https://secure.geonames.org/postalCodeLookupJSON?postalcode=' + postalcode + '&country=' + countryVal + '&callback=getLocation&username=norvital';

        // Create a new script object
        aObj = new JSONscriptRequest(request);
        // Build the script tag
        aObj.buildScriptTag();
        // Execute (add) the script tag
        aObj.addScriptTag();
    }
};


module.exports = new CustomFormValidator();